
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLocationI as ObiLocationIElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-location-i.js';
 
 
 

 
 export const ObiLocationI = createComponent({
   react: React,
   tagName: 'obi-location-i',
   elementClass: ObiLocationIElement,
   events: {
     
   }
  });
 
 